export default {
  state: {
    mobileNo:'',
    verificationcode:'',
    receiptInfo:{

      // address: "阿斯顿发斯蒂芬"
      // aliasName: ""
      // area: "和平区"
      // city: "天津市"
      // emailAddress: ""
      // id: 1559
      // province: "天津市"
      // telephone: "18529531779"
      // userName: "19529531779"


      id: '',
      sourceId: '',
      userName:'',
      emailAddress: '',
      aliasName: '',
      province: '',
      city: '',
      area:'',
      address: '',
      telephone: '手动添加收货地址',
      isDefault: ''
    },
    lotteryInfo: {  //中奖信息
      address: false,
      confirmationAward: true,
      prizeType: -1,
      needMobileno: true,
      needAddress: false,
      msg:''
    },
  },
  //同步更新数据
  mutations: {
    updateReceiptInfo(state,data){
      console.log('data==')
      console.log(data)
      state.receiptInfo = data
    },
    updateMobileNo(state, data) {
      console.log(data)
      state.mobileNo = data
    },
    updateVerificationcode(state, data) {
      state.verificationcode = data
    },
    updateLotteryInfo(state, data) {
      state.lotteryInfo = data
    },

  },
  getters: {
    getMobileNo(state){
      return state.mobileNo
    },
    getVerificationcode(state){
      return state.verificationcode
    },
    getLotteryInfo(state){
      return  state.lotteryInfo
    },

  },
  //异步更新数据
  actions: {
    memberinteraction: () => {
      let menberId = {
        "memberId": "1"
      }
      $axios({
        methods:'post',
        data:menberId,
        url:'/crm/memberinteraction',
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(res=>{
        this.a.mutations.update_memberinteraction(this.a.state, data.data.data)
      })
      // $axios.post('/crm/memberinteraction', menberId).then(
      //   data => {
      //     this.a.mutations.update_memberinteraction(this.a.state, data.data.data)
      //   }
      // )
    },
    birthdaynotify: (state,times) => {
      let period = times
      console.log(period)
      $axios({
        method: "post",
        data: {
          fromDate:period.fromDate,
          toDate:period.toDate
        },
        url: 'crm/birthdaynotifyd',
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(res => {
        if(res.data.scode == "0"){
        }
      });

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/plaidLottery/plaidLotteryPersistentData.js